import handleError from '../../helpers/gameHandlers/handleError';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { WS } from '../../socket/websocket';
// import ErrorPage from '../../Error'

class WSConnectionProvider {
	constructor(WS_URL) {
		this.WS_URL = WS_URL;
		this.socket = new WS(WS_URL, this.receiveMessage.bind(this)).start();
		this.errorPage = null;
	}
	sendSettings(sett) {
		this.socket.sendMessage(sett);
	}
	bet(bet) {
		this.saveBet(bet);
		this.socket.sendMessage(bet);
	}

	getQuest(quest) {
		this.socket.sendMessage(quest);
	}

	saveBet(bet) {
		const parsed = JSON.parse(bet);
		let currentIndex = GameConfigs.config.bet_steps.indexOf(parsed.data.amount);
		let b = {};
		if (currentIndex === -1) {
			currentIndex = 0;
		}
		b['current_bet'] = currentIndex;
		HELPERS.setSettings(b);
	}
	asyncBet(bet) {
		this.saveBet(bet);
		this.socket.sendMessage(bet);
		return new Promise((resolve, reject) => {
			this.socket.receiveMessage = (response) => {
				this.receiveMessage(response);
				resolve(response);
			};
		});
	}

	bonusRoundStep(step) {
		// GameConfigs.win = 0
		this.socket.sendMessage(step);
	}

	freeRoundStep(step) {
		// GameConfigs.win = 0
		this.socket.sendMessage(step);
	}
	receiveMessage(e) {
		if (e === null) return console.log('receiveMessage msg === null ', e);
		else if (e.code) {
			handleError(e, GameConfigs.App);
			console.error(
				'%cERROR!',
				'color:aqua; background: red; padding: 10px; border-radius: 4px',
				e
			);
		} else {
			HELPERS.dispatchCustomEvent(EVENTS.SERVER_MSG, e);
		}
	}

	dispatch(e) {
		if (e === null) return console.log('receiveMessage msg === null ', e);
		else if (e.code) {
			handleError(e, GameConfigs.App);
			console.error(
				'%cERROR!',
				'color:aqua; background: red; padding: 10px; border-radius: 4px',
				e
			);
		} else {
			HELPERS.dispatchCustomEvent(EVENTS.SERVER_MSG, e);
		}
	}
}

export default WSConnectionProvider;
